import React from 'react';
import { observer } from 'mobx-react';
import { OEToggle } from '../../global/oe-toggle/oe-toggle';
import Text from '../../global/text/text';
import { CommonPopupBodyFooterLayout } from '../../global/common-popup/common-popup-body-footer-layout';
import { RegistrationApprovalFormVM } from './registration-approval-form.viewmodel';
import {
    REGISTRATION_APPROVAL_STATUS_TEXT,
    REQUEST_ACCESS_CODE_REGISTRATION_APPROVAL_STATUS_TEXT,
    COORDINATOR_DENIED_NOTIFICATIONS_STATUS_TEXT,
    COORDINATOR_DENIED_NOTIFICATIONS_INFO_TEXT
} from '../../../constants/registration-approval.constants';
import { AccountAdminSettingFormFooter } from '../common/account-admin-setting-form-footer';
import { EnablementStatus } from '../../../constants/common.constants';
import { InfoPopover } from '../../global/info-popover/info-popover';

interface IRegistrationApprovalnFormPresentationProps {
    vm: RegistrationApprovalFormVM;
}

const RegistrationApprovalFormPresentation = observer(
    (props: IRegistrationApprovalnFormPresentationProps) => {
        const { vm } = props;

        return (
            <CommonPopupBodyFooterLayout
                body={
                    <>
                        <div className='oe-form'>
                            <div className='oe-form__body'>
                                <div className='m-top-10px m-bottom-0px flex center'>
                                    <OEToggle
                                        isSelected={vm.settingsEntity.enabled}
                                        onClick={vm.settingsEntity.toggleEnabled}
                                        dataTestId='toggle-registration-approval'
                                    />
                                    <Text
                                        {...REGISTRATION_APPROVAL_STATUS_TEXT}
                                        values={{
                                            suffix: vm.settingsEntity.suffix
                                        }}
                                        className='line-height-25px'
                                    />
                                </div>

                                <div className='m-top-20px m-bottom-0px flex center'>
                                    <OEToggle
                                        isSelected={vm.isRequestAccessCodeRegistrationApprovalEnabled}
                                        onClick={vm.toggleRequestAccessCodeRegistrationApproval}
                                        dataTestId='toggle-request-access-code-registration-approval'
                                    />
                                    <Text
                                        {...REQUEST_ACCESS_CODE_REGISTRATION_APPROVAL_STATUS_TEXT}
                                        values={{
                                            suffix: vm.isRequestAccessCodeRegistrationApprovalEnabled
                                                ? EnablementStatus.ENABLED
                                                : EnablementStatus.DISABLED
                                        }}
                                        className='line-height-25px'
                                    />
                                </div>

                                {vm.shouldShowCoordinatorDeniedNotifications && (
                                    <div className='m-top-20px m-bottom-0px flex center'>
                                        <OEToggle
                                            isSelected={vm.isCoordinatorDeniedNotificationsEnabled}
                                            onClick={vm.toggleCoordinatorDeniedNotifications}
                                            dataTestId='toggle-coordinator-denied-notifications'
                                        />
                                        <Text
                                            {...COORDINATOR_DENIED_NOTIFICATIONS_STATUS_TEXT}
                                            values={{
                                                suffix: vm.isCoordinatorDeniedNotificationsEnabled
                                                    ? EnablementStatus.ENABLED
                                                    : EnablementStatus.DISABLED
                                            }}
                                            className='line-height-25px'
                                        />
                                        <InfoPopover className='m-left-8px'>
                                            <div>{COORDINATOR_DENIED_NOTIFICATIONS_INFO_TEXT.defaultMessage}</div>
                                        </InfoPopover>
                                    </div>
                                )}
                            </div>
                        </div>
                    </>
                }
                footer={
                    <AccountAdminSettingFormFooter
                        handleClose={vm.handleClose}
                        handleSubmit={vm.handleSubmit}
                        isDisabled={vm.saving}
                    />
                }
            />
        );
    }
);

export { RegistrationApprovalFormPresentation };
